
import '@/assets/scss/2_component/_category.scss'

import { commonfunc } from '~/mixin/common'
import { pushGtmData } from '~/utils/gtm'
export default {
  components: {
  },
  mixins: [commonfunc],
  props: {
    active: {
      type: Number,
      default: 1
    },
    giftCardDisabled: {
      type: Boolean,
      default: false
    },
    pushGtmCtgrYn: { // 랭킹 카테고리 클릭 시 gtm 정보 push 여부, DEV-3999
      type: Boolean,
      default: false
    },
    clickedActiveCategory: {
      type: Object,
      default: () => {
        return {}
      }
    }
  },
  data () {
    return {
      cateSwiperOpt: {
        slidesPerView: 'auto',
        loop: false,
        lazy: true,
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev'
        },
        allowTouchMove: true
      },
      activeIdx: 0,
      categoryList: [
        {
          txt: '전체',
          imgName: '',
          ctgrId: ''
        }
      ],
      isSwiperLoaded: false,
      ctgrList: [],
      activeTab: 0, // active tab 인덱스
      paramCtgrNo: this.lgCtgrNo,
      naviShow: true,
      lgCtgrForm: {},
    }
  },
  created () {
    if (this.active !== '' && !this.isPopState) {
      this.activeIdx = this.active - 1
    } else if (this.isPopState) {
      const lgCtgrData = JSON.parse(sessionStorage.getItem('lgCtgrData'))
      this.activeIdx = lgCtgrData.lgCtgrIdx
      this.setCtrgrId(lgCtgrData.lgCtgrNo)
    }
    // this.cateSwiperOpt.slidesPerView = 13
  },
  mounted () {
    this.selCtgrList()
    this.$nextTick(() => {
      if (Object.keys(this.clickedActiveCategory).length > 0 && !this.isPopState) {
        this.activeIdx = this.clickedActiveCategory.index
        this.setCtrgrId(this.clickedActiveCategory.id)
      }
    })
  },
  beforeDestroy () {
    this.lgCtgrForm.lgCtgrIdx = this.activeIdx
    this.lgCtgrForm.lgCtgrNo = this.categoryList[this.activeIdx]?.ctgrId
    sessionStorage.setItem('lgCtgrData', JSON.stringify(this.lgCtgrForm))
  },
  methods: {
    ctgrClick ($event, idx, ctgrId) {
      console.log('event', $event)
      console.log('idx', idx)
      console.log('ctgrId', ctgrId)

      this.activeIdx = idx

      // 랭킹 카테고리 클릭 시 gtm 정보 push, DEV-3999
      if (this.pushGtmCtgrYn) {
        const item = {
          ctgrId: this.categoryList[idx]?.ctgrId,
          ctgrNm: this.categoryList[idx]?.txt
        }

        pushGtmData(item, 'clickCategoryBtn')
      }

      this.setCtrgrId(ctgrId)
      this.setParamData(ctgrId)
    },
    errorImage (e) {
      e.target.src = '/images/tempLy/ico_prob_cate13.png'
    },
    selCtgrList () {
      console.log('paramCtgrNo', this.paramCtgrNo)
      const testData = { // 대카테고리 조회 리퀘스트 파라미터
        exhCnrId: this.paramCtgrNo
      }
      this.$AxiosBuilder
        .data(testData)
        .build()
        .post('/ds/ctgr')
        .then((res) => {
          const ctgrList = res.data.data
          ctgrList.forEach((item, i) => {
            const newItem = Object.assign({}, {
              txt: item.exhCtgrNm,
              imgName: this.imgUrlMaker(item.pcIconAtchFileUrl, '/dims/resize/100/quality/90'), // 수정 필요
              ctgrId: item.exhCtgrNo
            })

            this.categoryList.push(newItem)
          })

          // 카테고리 갯수 설정 노출개수 이하 시 navigation 숨김, 클릭 안됨
          if (this.categoryList.length <= this.cateSwiperOpt.slidesPerView) {
            this.naviShow = false
            this.cateSwiperOpt.allowTouchMove = false
          }

          // 랭킹 탭 내 상품권 카테고리 미노출 처리(DEV-2601, 240603)
          if (this.giftCardDisabled && this.giftCardDisabled === true) {
            const idx = this.categoryList.findIndex(e => e.ctgrId === 'CTGR_00847')

            this.categoryList.splice(idx)
          }
          this.$nextTick(() => {
            this.isSwiperLoaded = true
          })
        }).catch((err) => {
          console.log(err)
        })
    },
    setParamData (str) {
      this.paramCtgrNo = str
      console.log('this.paramCtgrNo', this.paramCtgrNo)
    },
    setCtrgrId (largeExhCtgrNo) {
      console.log('카테 컴포넌트 테스트 str ', largeExhCtgrNo)
      //  this.$emit('callSelectItemBnn', largeExhCtgrNo)
      this.$emit('callSearchTotal', largeExhCtgrNo)

    //  this.$emit('callHandlerFilter')
    }
  }
}
